export const state = {
  data: {
    error: false,
    message: '',
    type: 'success',
  },
};

export const mutations = {
  changeNotif(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  showNotif({ commit, state }, payload = null) {
    commit('changeNotif', payload);

    this._vm.$toast(state.data.message, {
      type: state.data.type,
      timeout: 3000,
      onClose: () => {
        commit('changeNotif', {
          message: '',
          type: 'success',
        });
      },
    });
  },

  showError({ commit }, payload = null) {
    commit('changeNotif', {
      error: payload,
    });
  },
};

// shortcut to set notif
export const showNotif = async (dispatch, data) => {
  await dispatch('notification/showNotif', { ...data }, { root: true });
};
